
import React from "react";
import { FormLabel, FormToggle, FormElement, FormInput } from "../../../components/StyledElements";
import { useAgents } from "contexts/AgentsContext";


export const CoreDetails = ({ style = {}, onSelectTab = () => { } }) => {
  const { updatedWorkflow, setUpdatedWorkflow } = useAgents();

  return (
    <div style={{ display: "flex", flexDirection: "column", ...style }}>

      <FormElement style={{ flexDirection: "column", display: "flex" }}>
        {
          updatedWorkflow?.document_count ? (
            <FormLabel label={`${updatedWorkflow.document_count} Items`} />
          ) : null}
        {
          updatedWorkflow?.collection_chunk_count ? (
            <FormLabel label={`${updatedWorkflow.collection_chunk_count} Chunked Items`} />
          ) : null}
      </FormElement>

      <FormElement style={{ flexDirection: "row", display: "flex", alignItems: "center", gap: "10px" }}>
        <FormLabel label={`Published (${updatedWorkflow?.published ? "Yes" : "No"})`} style={{ margin: 0 }} />
        <FormToggle
          checked={updatedWorkflow?.published ?? false}
          onChange={(e) => {
            updatedWorkflow.published = e.target.checked;
            setUpdatedWorkflow({ ...updatedWorkflow });
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Public ID" />
        <FormInput disabled type="text" value={updatedWorkflow?.public_id ?? ""} />
      </FormElement>
      <FormElement>
        <FormLabel label="Name" />
        <FormInput type="text" placeholder="Enter workflow name" value={updatedWorkflow?.name ?? ""}
          onChange={(e) => {
            setUpdatedWorkflow({ ...updatedWorkflow, name: e.target.value });
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Description" />
        <FormInput
          as="textarea"
          rows={5}
          placeholder="Enter description"
          style={{ resize: "vertical" }}
          value={updatedWorkflow?.description ?? ""}
          onChange={(e) => {
            updatedWorkflow.description = e.target.value;
            setUpdatedWorkflow({ ...updatedWorkflow });
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Purpose" />
        <FormInput
          as="textarea"
          rows={5}
          placeholder="Enter workflow purpose for discovery"
          style={{ resize: "vertical" }}
          value={updatedWorkflow?.purpose ?? ""}
          onChange={(e) => {
            updatedWorkflow.purpose = e.target.value;
            setUpdatedWorkflow({ ...updatedWorkflow });
          }}
        />
      </FormElement>
    </div>
  );
};

export default CoreDetails;
